import type { ErrorView } from '@krp/client-runtime'

/** Служебная строка ошибки: код и корреляция — для отчёта поддержке. */
export function errorMeta(error: ErrorView | null): string | undefined {
  if (error === null) return undefined
  return error.correlationId !== null ? `Код: ${error.code} · запрос ${error.correlationId}` : `Код: ${error.code}`
}
